import React, { useRef, useEffect } from 'react';
import MessageBubble from './MessageBubble';
import { PENDING } from '../../../../store/globalStatuses/globalStatuses';
import styles from '../../WabaChats.module.scss';

export default function MessageThread({ messages, status, hasMore, onLoadMore, branchId, onDismiss }) {
    const bottomRef = useRef(null);
    const containerRef = useRef(null);
    const prevLengthRef = useRef(0);
    const isLoadingMoreRef = useRef(false);

    useEffect(() => {
        if (messages.length > prevLengthRef.current && !isLoadingMoreRef.current) {
            bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
        isLoadingMoreRef.current = false;
        prevLengthRef.current = messages.length;
    }, [messages.length]);

    const handleScroll = () => {
        if (containerRef.current?.scrollTop < 10 && hasMore && status !== PENDING) {
            isLoadingMoreRef.current = true;
            onLoadMore();
        }
    };

    if (status === PENDING) return <div className={styles.threadLoading}>Loading messages...</div>;
    return (
        <div className={styles.messageThread} ref={containerRef} onScroll={handleScroll}>
            {hasMore && messages.length > 0 && <div className={styles.loadMore} onClick={onLoadMore}>Load earlier messages</div>}
            {messages.map(msg => (
                <MessageBubble key={msg.id} message={msg} branchId={branchId} onDismiss={onDismiss} />
            ))}
            <div ref={bottomRef} />
        </div>
    );
}
